import styled from "styled-components";

export const ExerciseWeeklyList = styled.ul`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;
